import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const STEPS = [
  { label: "1 BUSINESS", size: "text-2xl sm:text-3xl", accent: "#FF8800" },
  { label: "10 JOBS", size: "text-3xl sm:text-4xl", accent: "#00B0FF" },
  { label: "100 BUSINESSES", size: "text-4xl sm:text-5xl", accent: "#00E676" },
  { label: "1,000 BUSINESSES", size: "text-4xl sm:text-6xl", accent: "#00B0FF" },
  { label: "10,000 BUSINESSES", size: "text-5xl sm:text-7xl", accent: "#FF8800" },
  { label: "MILLIONS OF OPPORTUNITIES", size: "text-4xl sm:text-6xl", accent: "#00E676", gradient: true },
];

export function EmploymentVision() {
  return (
    <section data-testid="employment-vision-section" className="relative py-20 sm:py-28 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,230,118,0.05),transparent_55%)] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-mono-tech text-xs tracking-[0.35em] text-[#00B0FF] uppercase mb-4">The Employment Vision</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white" data-testid="employment-vision-headline">
            FROM JOB SEEKERS TO <span className="text-gradient-saffron">JOB CREATORS</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed max-w-3xl mx-auto">
            LaunchLab believes India's growth becomes stronger when more people have the
            opportunity to build businesses — rather than only search for employment.
          </p>
        </motion.div>

        <div className="mt-16 flex flex-col items-center gap-5" data-testid="employment-cascade">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30, scale: 0.92 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.6 }}
              className="flex flex-col items-center gap-5"
              data-testid={`employment-step-${i}`}
            >
              <span
                className={`font-display font-extrabold tracking-tight ${s.size} ${
                  s.gradient ? "text-gradient-india" : ""
                }`}
                style={s.gradient ? undefined : { color: s.accent, textShadow: `0 0 40px ${s.accent}55` }}
              >
                {s.label}
              </span>
              {i < STEPS.length - 1 && <ArrowDown className="w-5 h-5 text-slate-600" />}
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-14 font-mono-tech text-[10px] sm:text-xs tracking-[0.2em] text-slate-500 uppercase max-w-xl mx-auto leading-relaxed"
          data-testid="employment-disclaimer"
        >
          A long-term vision for entrepreneurial impact — not a statement of current
          achievements or guaranteed results.
        </motion.p>
      </div>
    </section>
  );
}
